import { lazy } from 'react'

export const RestaurantKnowledgeBaseLazy = lazy(
  () => import('./RestaurantKnowledgeBase'),
)
